module.exports = __webpack_public_path__ + "static/img/PC-3.748a0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-3.png
// module id = dPA2
// module chunks = 0